import React from "react";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import Stack from "@mui/material/Stack";

import { useGetAllProjectIdsQuery, useGetProjectByIdQuery } from "services/project/projectApi";
import ProjectTile from "./ProjectTile";
import { useLocation, useParams } from "react-router-dom";
import { ProjectSlug } from "services/project/typing";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";


export interface ProjectLensProps {
  projectIds?: Array<ProjectSlug> | undefined;
  // lens: string;
};



const dateCompare = (a: string, b: string) => { 
  const dateA = new Date(a);
  const dateB = new Date(b);
  if (dateB > dateA) {
    return -1;
  } else if (dateA > dateB) {
    return 1;
  };
    return 0;
}

// const sequentialCompare(a: { main_s: number, }, b)

// const comparators: Record<Comparator, ((a: ProjectSlug, b: ProjectSlug) => number)> = {
  // 'alphanumeric': (a, b) => a.title.localeCompare(b.title),
  // 'created': dateCompare(a.created, b.created),
  // 'modified': dateCompare(a.modified, b.modified)
  // 'sequential': (a, b)
// };

export type Comparator = 'sequential' | 'created' | 'modified' | 'alphanumeric';

const ProjectLens = (props: ProjectLensProps)  => {
  const location = useLocation();
  const { projectId } = useParams();
  const theme = useTheme();
  // const matchDownMd = useMediaQuery(theme.breakpoints.down('sm'));
  // const greaterThanLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const midToLarge = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const smallToMid = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const lessThanSmall = useMediaQuery(theme.breakpoints.down("sm"));

  let cols = 1;

  if (lessThanSmall) {
    cols = 1;
  } else if (smallToMid) {
    cols = 2;
  } else if (midToLarge) {
    cols = 3;
  } else {
    // Large to xl
    cols = 4;
  } 
  // const [ comparator, setCommparator ] = React.useState<Comparator>('sequential');
  // Get the current project name/id
  // use the id to fetch the list of subprojects

  
  const { data: project, error, isLoading } = useGetProjectByIdQuery({ id: projectId ?? '404' }, { skip: typeof projectId === 'undefined' || !!location.state });
  
  const projectIds: Array<ProjectSlug> = React.useMemo(updateProjectIds, [ props.projectIds, location?.state, project?.relations]);
  
  if (isLoading) {
    return null;
  }

  function updateProjectIds() {
    // Update the array of projectIds from order of importance:
    // 1. Use props if provided
    // 2. Then, try locations state if provided,
    // 3. If nothing was provided, look for data that would be fetched if any of these were not provided
    // 4. Use an empty array as their are no projectIds available if we make it this far
    return props.projectIds ?? location.state?.relations?.['children'] ?? project?.relations?.['children'] ?? [];
  };
  




  if ( typeof projectIds === 'undefined' || projectIds.length === 0) {
    return <Box>Gomen ne... This project has no sub projects right now</Box>;
  }

  return (
    <Stack m={1} alignItems={'center'}>
      <ImageList
        cols={ cols }
        rowHeight={380}
      >
        { projectIds.map((project, index) => <ProjectTile key={`${project.uid}-${index}`} uid={project.uid} />) }
      </ImageList>
    </Stack>
  );
}


export default ProjectLens;